import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import validate from '@zzzj/zzzj/src/validate/index';
export default _objectSpread({}, validate);